// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comp-footer {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  border-left: 1px solid var(--color-navLeft-border);
  background: var(--color-navLeft-background);
  color: var(--color-navLeft-button-active);
}
.comp-footer .footer-fullScreenStopper {
  cursor: ns-resize;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}
.comp-footer .footer-mouseBar {
  cursor: ns-resize;
  width: 100%;
  height: 4px;
  border-top: 1px solid var(--color-navLeft-border);
  position: relative;
}
.comp-footer .footer-mouseBarActive {
  border-top: 2px solid var(--color-featureColor);
}
.comp-footer .footer-mouseBar:hover {
  border-top: 2px solid var(--color-featureColor);
  margin-bottom: -1px;
}
.comp-footer .footer-mouseBarClose {
  border-top: 1px solid transparent;
}
.comp-footer .footer-mouseBarClose:hover {
  border-top: 2px solid var(--color-featureColor);
}
.comp-footer .footer-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.comp-footer .footer-content .content-inner {
  display: flex;
  flex-direction: column;
  flex: 20px 1;
  overflow: auto;
}
.comp-footer .footer-content .content-inner .inner-taskbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 8px;
  font-size: 10px;
}
.comp-footer .footer-content .content-inner .inner-taskbar .taskbar-left {
  display: flex;
  gap: 16px;
}
.comp-footer .footer-content .content-inner .inner-taskbar .taskbar-right {
  display: flex;
  gap: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/footer/footer.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,8BAAA;EACA,kDAAA;EACA,2CAAA;EACA,yCAAA;AACF;AACE;EACE,iBAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AACJ;AAEE;EACE,iBAAA;EACA,WAAA;EACA,WAAA;EACA,iDAAA;EACA,kBAAA;AAAJ;AAGE;EACE,+CAAA;AADJ;AAIE;EACE,+CAAA;EACA,mBAAA;AAFJ;AAKE;EACE,iCAAA;AAHJ;AAME;EACE,+CAAA;AAJJ;AAOE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AALJ;AAOI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AALN;AAOM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;AALR;AAOQ;EACE,aAAA;EACA,SAAA;AALV;AAQQ;EACE,aAAA;EACA,QAAA;AANV","sourcesContent":[".comp-footer {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: space-between;\n  border-left: 1px solid var(--color-navLeft-border);\n  background: var(--color-navLeft-background);\n  color: var(--color-navLeft-button-active);\n\n  .footer-fullScreenStopper {\n    cursor: ns-resize;\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 100;\n  }\n\n  .footer-mouseBar {\n    cursor: ns-resize;\n    width: 100%;\n    height: 4px;\n    border-top: 1px solid var(--color-navLeft-border);\n    position: relative;\n  }\n\n  .footer-mouseBarActive {\n    border-top: 2px solid var(--color-featureColor);\n  }\n\n  .footer-mouseBar:hover {\n    border-top: 2px solid var(--color-featureColor);\n    margin-bottom: -1px;\n  }\n\n  .footer-mouseBarClose {\n    border-top: 1px solid transparent;\n  }\n\n  .footer-mouseBarClose:hover {\n    border-top: 2px solid var(--color-featureColor);\n  }\n\n  .footer-content {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n\n    .content-inner {\n      display: flex;\n      flex-direction: column;\n      flex: 20px;\n      overflow: auto;\n\n      .inner-taskbar {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        padding: 0 8px;\n        font-size: 10px;\n\n        .taskbar-left {\n          display: flex;\n          gap: 16px;\n        }\n\n        .taskbar-right {\n          display: flex;\n          gap: 4px;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
